export default [
  {
    id: 'intro-video',
    type: 'video',
    src: require('info/video/intro.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(2)
    }
  },

  {
    id: 'outside-video-atutak',
    type: 'video',
    src: require('info/video/outside.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(5)
    }
  },

  {
    id: 'tunnel-entrance-video-tuk',
    type: 'video',
    src: require('info/video/erik_first.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(6)
    }
  },

  {
    id: 'tunnel-recroom-audio-tuk',
    type: 'audio',
    src: require('info/video/erik_second.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(7)
    }
  },

  {
    id: 'recroom-video-poldi1',
    type: 'video',
    src: require('info/video/poldi_first.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(8)
    }
  },

  {
    id: 'recroom-video-poldi2',
    type: 'video',
    src: require('info/video/poldi_second.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(9)
    }
  },

  {
    id: 'recroom-video-freeman',
    type: 'video',
    src: require('info/video/franklin_first.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(10)
    }
  },

  {
    id: 'recroom-video-soren1',
    type: 'video',
    src: require('info/video/test.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(11)
    }
  },

  {
    id: 'recroom-video-soren2',
    type: 'video',
    src: require('info/video/soren_second.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(12)
    }
  },

  {
    id: 'recroom-video-projector',
    type: 'video',
    src: require('info/video/projector.mp4'),
    // onClose: function(vnode) {
    //   vnode.attrs.toggleLogBook(12)
    // }
  },
  {
    id: 'quarters-video-soren1',
    type: 'video',
    src: require('info/video/soren_quarters1.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(13)
    }
  },

  {
    id: 'quarters-video-soren2',
    type: 'video',
    src: require('info/video/soren_quarters2.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(14)
    }
  },
  {
    id: 'quarters1-inuit-video',
    type: 'video',
    src: require('info/video/inuit_quarters.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(15)
    }
  },
  {
    id: 'quarters-video-poldi',
    type: 'video',
    src: require('info/video/quarters_poldi.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(16)
    }
  },
  {
    id: 'quarters2-inuit-video',
    type: 'video',
    src: require('info/video/inuit_quarters2.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(17)
    }
  },
  {
    id: 'tunnel-doctor-doctor',
    type: 'video',
    src: require('info/video/doctor.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(21)
    }
  },
  {
    id: 'reactor1-reactor',
    type: 'video',
    src: require('info/video/reactor.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(22)
    }
  },
  {
    id: 'reactor1-video-erik1',
    type: 'video',
    src: require('info/video/reactor_erik1.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(23)
    }
  },
  {
    id: 'reactor1-video-erik2',
    type: 'video',
    src: require('info/video/reactor_erik2.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(24)
    }
  },
  {
    id: 'reactor2-general',
    type: 'video',
    src: require('info/video/reactor_general.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(25)
    }
  },
  {
    id: 'rails1-video-tuk',
    type: 'video',
    src: require('info/video/rails_erik1.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(26)
    }
  },
  {
    id: 'rails1-video-william',
    type: 'video',
    src: require('info/video/journalist.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(27)
    }
  },
  {
    id: 'tunnel-headquarters-video-tuk',
    type: 'audio',
    src: require('info/audio/erik_hq.mp4'),
    onClose: function(vnode) {
      //vnode.attrs.toggleLogBook(22)
    }
  },
  {
    id: 'headquarters1-video-major1',
    type: 'video',
    src: require('info/video/hq_major1.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(18)
    }
  },
  {
    id: 'headquarters1-video-major2',
    type: 'video',
    src: require('info/video/hq_major2.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(19)
    }
  },
  {
    id: 'headquarters1-video-general',
    type: 'video',
    src: require('info/video/hq_general1.mp4'),
    onClose: function(vnode) {
      vnode.attrs.toggleLogBook(20)
    }
  },
  {
    id: 'quarters1-book',
    type: 'text',
    isImage: true,
    src: require('info/images/book.jpg'),
    width: '90vh',
    close_button: '-140px',
    text: '',      
    onClose: function(vnode) {
    }    
  },
  {
    id: 'quarters1-clock',
    type: 'text',
    isImage: true,
    src: require('info/images/day.png'),
    text: ''
  },
  {
    id: 'tunnel-quarters-movienight',
    type: 'text',
    isImage: true,
    src: require('info/images/MovieTonightPost.jpg'),
    text: '<div onclick="window.open(\'https://www.youtube.com/watch?v=uZ1f0OA752w\', \'_blank\');" style="cursor: pointer; width: 37vh; height: 6vh; position: absolute; top: -10vh;"></div>' +
    '<div onclick="window.open(\'https://www.youtube.com/watch?v=wHUSIJx3630\', \'_blank\');" style="cursor: pointer; width: 37vh; height: 6vh; position: absolute;"></div>' +
    '<div onclick="window.open(\'https://www.youtube.com/watch?v=9GzCG6lpFUw\', \'_blank\');" style="cursor: pointer; width: 37vh; height: 6vh; position: absolute; top: 15vh;"></div>' 
  },
  {
    id: 'headquarters1-analysis',
    type: 'text',
    isImage: true,
    src:  require('info/images/analysis.png'),
    text: ''
  },
  {
    id: 'headquarters2-iceworm',
    type: 'text',
    isImage: true,
    src:  require('info/images/frontpage.jpg'),
    text: ''
  },
  {
    id: 'recroom-entrance',
    type: 'text',
    isImage: false,
    text: '<p class="log-book-text mod-h3">Mission</p>' +
    '<p class="log-book-text">Du er på vej ind i Camp Centurys fællesrum. Det er her soldaterne spiller billard, drikker øl og fortæller historier. Prøv at finde svar på første spørgsmål:</p>' +
    '<ul><li><p class="log-book-text">Hvorfor har amerikanerne så travlt med at lave videnskabelige og militære projekter som Camp Century, at de ikke venter på tilladelse fra Danmark?</p></li></ul>'
  },
  {
    id: 'recroom-leave',
    type: 'text',
    isImage: false,
    text: '<p class="log-book-text">Har du lyttet til alle personerne i fællesrummet?</p>' +
    '<p class="log-book-text">Så kan du måske svare på det spørgsmål, du blev stillet ved indgangen til rummet.  </p>' +
    '<p class="log-book-text">Overvej og notér: </p>' +
    '<ul><li><p class="log-book-text">Hvorfor har amerikanerne så travlt med at lave videnskabelige og militære projekter som Camp Century, at de ikke venter på tilladelse fra Danmark?</p></li></ul>' +
    '<p class="log-book-text">Du er klar til at fortsætte gennem tunnellerne. Måske skulle du kigge forbi spejderen Sørens værelse?</p>'
  },
  {
    id: 'quarters-entrance',
    type: 'text',
    isImage: false,
    text: '<p class="log-book-text mod-h3">Mission</p>' +
    '<p class="log-book-text">Søren inviterer dig indenfor på sit værelse. Han fortæller, at han har mødt nogle få Thuleboere, der boede i området før Thulebasen og Camp Century blev bygget.</p>' +
    '<ul><li><p class="log-book-text">Men hvad er der sket med alle de andre Thuleboere, der levede her?</p></li></ul>' +
    '<p class="log-book-text">Prøv at finde svar på spørgsmålet.</p>'
  },
  {
    id: 'quarters-leave',
    type: 'text',
    isImage: false,
    text: '<p class="log-book-text">Har du hørt, hvad alle personer har at sige?</p>' +
    '<p class="log-book-text">Overvej og notér:</p>' +
    '<ul><li><p class="log-book-text">Hvad skete der med Thuleboerne, der boede ved de amerikanske militære områder?</p></li>'+
    '<li><p class="log-book-text">Kunne danskerne og amerikanerne have handlet anderledes? Hvordan?</p></li></ul>' +
    '<p class="log-book-text">Gå videre til reaktorrummet for at undersøge flere kontroversielle forhold omkring basen. Reaktoren er Camp Century’s kraftcenter. Og så er den tæt forbundet til basens tophemmelige formål ...   </p>'
  },
  {
    id: 'reactorroom-entrance',
    type: 'text',
    isImage: false,
    text: '<p class="log-book-text mod-h3">Mission</p>' +
    '<p class="log-book-text">Du er på vej ind i Camp Century’s kraftcenter - reaktorrummet. </p>' +
    '<p class="log-book-text">Find ud af hvorfor amerikanerne har bygget en mobil atomreaktor under indlandsisen.  </p>' +
    '<ul><li><p class="log-book-text">Hvilke muligheder giver atomenergi det amerikanske militær? </p></li>' +
    '<li><p class="log-book-text">Hvordan bør Danmark tackle hele atomspørgsmålet?</p></li></ul>'
  },
  {
    id: 'reactorroom-leave',
    type: 'text',
    isImage: false,
    text: '<p class="log-book-text">Du har nu besøgt atomreaktoren. </p>' +
    '<p class="log-book-text">Overvej og notér:</p>' +
    '<ul><li><p class="log-book-text">Hvilke muligheder giver atomenergi det amerikanske militær? </p></li>'+
    '<li><p class="log-book-text">Hvorfor er reaktoren et problem for Danmark?</p></li></ul>'+
    '<p class="log-book-text">Find nu de skjulte tunneller agent Tuk Erik Jørgen-Jensen taler om. De vil bringe dig tættere på Camp Century’s hemmelighed. </p>',
    onClose: function(vnode, m) {
      if (vnode.attrs.viewedScenes.includes("reactor1") && vnode.attrs.viewedScenes.includes("rails1")) {
        m.route.set("/pano/tunnel-reactor?overlay=hq-unlocked-note")
      }
    }
  },
  {
    id: 'railway-entrance',
    type: 'text',
    isImage: false,
    text: '<p class="log-book-text mod-h3">Mission</p>' +
    '<p class="log-book-text">Du når frem til en hesteskoformet tunnel, som ikke er på det officielle kort over Camp Century. Her er togskinner med åbne vogne på. Erik er fulgt med. Her er også en amerikansk journalist. Journalisten har nogle interessante tanker om basens skjulte formål.</p>' +
    '<ul><li><p class="log-book-text">Hvad tror du, skinnerne skal bruges til?</p></li>' +
    '<li><p class="log-book-text">Hvad er forskellen på dét journalisten først skriver og det, han senere trykker i avisen?</p></li></ul>'
  },
  {
    id: 'railway-leave',
    type: 'text',
    isImage: false,
    text: '<p class="log-book-text">Hvad fandt du ud af ved jernbanesporet?</p>' +
    '<p class="log-book-text">Overvej og notér:</p>' +
    '<ul><li><p class="log-book-text">Hvad tror du, skinnerne skal bruges til?</p></li>'+
    '<li><p class="log-book-text">Hvad har de danske myndigheder fået fjernet fra journalistens artikel?</p></li>'+
    '<li><p class="log-book-text">Hvorfor tror du, man har fjernet det? Og er det okay at gøre?</p></li></ul>'+
    '<p class="log-book-text">Du er tæt på at nå frem til Camp Century’s hemmelighed. Måske har du allerede regnet ud, hvad det amerikanske militær har af planer med Grønland? Fortsæt til kommandocentralen.</p>',
    onClose: function(vnode, m) {
      if (vnode.attrs.viewedScenes.includes("reactor1") && vnode.attrs.viewedScenes.includes("rails1")) {
        m.route.set("/pano/tunnel-rails?overlay=hq-unlocked-note")
      }
    }
  },
  {
    id: 'hq-entrance',
    type: 'text',
    isImage: false,
    text: '<p class="log-book-text mod-h3">Mission</p>' +
    '<p class="log-book-text">Du er nået ind til Camp Centurys kommandocentral, Head Quarters. Det er her, de afgørende beslutninger bliver taget. En højtstående oversergent er på besøg fra fastlandet. Han har en hemmelig plan med, som hverken Grønland eller Danmark kender til.</p>' +
    '<p class="log-book-text">Se hvad du kan finde ud af om planen. </p>' +
    '<ul><li><p class="log-book-text">Kan amerikanernes hemmelige plan retfærdiggøres, når man tager truslen fra Sovjet i betragtning?</p></li></ul>'
  },
  {
    id: 'hq-leave',
    type: 'text',
    isImage: false,
    text: '<p class="log-book-text">Du har nu fået et indblik i det tophemmelige Project Iceworm. Hvad tænker du?</p>' +
    '<p class="log-book-text">Overvej og notér:</p>' +
    '<ul><li><p class="log-book-text">Kan amerikanernes hemmelige Project Iceworm retfærdiggøres, når man tager truslen fra Sovjet i betragtning? </p></li>'+
    '<li><p class="log-book-text">Hvis amerikanerne indvier Danmark i planerne, hvad bør vi så sige og gøre? </p></li></ul>'+
    '<p class="log-book-text">Du har fundet ud af det hemmelige formål med Camp Century. Du skal nu forlade basen under isen - gå til enden af tunnelen og tryk på "tilbage til nutiden".</p>'
  },
  {
    id: 'hq-locked',
    type: 'text',
    isImage: false,
    text: '<p class="log-book-text">Stop! Du kan ikke komme ind i Kommandocentralen, før du har set atomreaktoren og fundet jernbanetunnelen. Du må finde stederne først og fuldføre din mission dér.</p>'     
  },
  {
    id: 'hq-unlocked-note',
    type: 'text',
    isImage: false,
    text: '<p class="log-book-text">Nu kan du besøge kommandocentralen. Den er længere tilbage mod indgangen.</p>'     
  },
  {
    id: 'end-locked-note',
    type: 'text',
    isImage: false,
    text: '<p class="log-book-text">Stop! Du kan ikke afslutte Camp Century, før du har besøgt Kommandocentralen. Vend om og fuldfør din mission dér.</p>'     
  },
  {
    id: 'end-unlocked-note',
    type: 'text',
    isImage: false,
    text: '<p class="log-book-text">Camp Century lukkede i 1964, og USA opgav Project Iceworm og planerne om et gigantisk missilsystem under indlandsisen. Det viste sig at være for dyrt og krævende at vedligeholde istunneller som dem i Camp Century.</p>' +

    '<p class="log-book-text">Atomreaktoren blev fjernet under dansk tilsyn. Men det meste af basen og dens lavradioaktive spildevand og kemiske affald blev efterladt. Det ligger i dag gemt 50-80 meter under isens overflade. </p>'+
    
    '<p class="log-book-text">Din rejse under isen har kastet lys over nogle af de dilemmaer, der knyttede sig til Den Kolde Krig - og over sikkerhedspolitik i det hele taget.</p>'+
    
    '<p class="log-book-text">Rejs nu til nutiden og mød den ægte agent Tuk Erik-Jørgen Jensen, spejderen Søren Gregersen - og flere personer med et helt særligt forhold til Camp Century.</p>'+
    
    '<p class="log-book-text">Og overvej så dine holdninger til en række dilemmaer. </p>',
    onClose: function(vnode, m) {
      window.location.href = "http://projecticeworm.dk/public_html/klynt/";
    }
  },
  {
    id: 'test-text',
    type: 'text',
    text:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
  }
]
